import { BadgeByProductProps } from "../types";
import { IconVariant } from "@/components/ui/badgeIcon";

export const PRODUCT_TYPE_MAPPING = {
  PROGRAMS: ["Certificate", "Professional Certificate", "XSeries"],
  DEGREES: [
    "Bachelors",
    "Masters",
    "Doctorate",
    "MicroBachelors",
    "MicroMasters",
  ],
  COURSES: ["Course"],
  EXEC_ED: ["Executive Education"],
} as const;

// TODO: temporary test - each card should have a different badge according to the rules it applies to
// the rules will be defined in a new ticket
export const BADGE_CONFIGURATION = {} as const;

export const MICRO_DEGREE_TYPES: string[] = [
  "MicroMasters",
  "MicroBachelors",
] as const;

export const DEFAULT_MICRO_DEGREE_CONFIG = {
  text: "College Credentials",
  icon: "program" as IconVariant,
} as const;

export const normalizeProductType = (productType: string): string => {
  if (PRODUCT_TYPE_MAPPING.PROGRAMS.includes(productType as any)) {
    return "Programs";
  }
  if (PRODUCT_TYPE_MAPPING.DEGREES.includes(productType as any)) {
    return "Degrees";
  }
  if (PRODUCT_TYPE_MAPPING.COURSES.includes(productType as any)) {
    return "Course";
  }
  if (PRODUCT_TYPE_MAPPING.EXEC_ED.includes(productType as any)) {
    return "Executive Education";
  }
  return productType;
};

export const getBadgeTypesForProduct = (
  productType: string,
  badgesByProduct?: BadgeByProductProps[],
): string[] => {
  const normalizedType = normalizeProductType(productType);
  const config = badgesByProduct?.find(
    (badge) => badge.productType === normalizedType,
  )?.badgesOrder;
  const configArray = config
    ? [...config.map((item: any) => item.badgesList)]
    : [];
  return configArray;
};
